/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Watch} from "vue-property-decorator";
import {UserModule} from '@/store/modules/user'
import {
    getCustomerListByEduCode,
    getFinanceOrderListByFinanceRepeatOrder,
    setFinanceMarketCost, setFinanceRepeatOrder
} from '@/api/financial-center'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import {formatDate} from '@/utils/timeFilter'
import {File} from "@/views/customer/customer-transfrom/edit-customer-info/interface";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components: {
        MoreUsersFilter
    }
})
export default class RepeatOrderAdd extends Vue {
    logList = []
    tableRandom = Math.random()
    tableKey = Math.random()
    tableData = []
    select = '0'  //
    formData = {
        repeatUserId: '', //撞单同事
        financeOrderId: '', //        订单id
        explain: '', //        撞单说明（文字）
        financeRepeatOrderExplainList: [],//    撞单说明（图片）
        url: '',//    图片链接
        name: '',//    图片名称
        directorUserId: '' ,//负责人id
        customerEduCode: '' ,// 客户识别号
        directorUserName: '' ,//负责人
    }


    fileList = []
    fileList1 = []
    disabledButton = false
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'
    backMoneyId: number = null
    orderId: number = null
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 草稿id
    operationShow = true
    backMoneyStatus = ''
    showInput: any = true

    formRules = {
        repeatUserId: [{required: true, message: '请选择撞单同事', trigger: ['change', 'blur']}],
        customerEduCode: [{required: true, message: '请填写客户识别号', trigger: ['change','blur']}],
    }

    // orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogTotal = 0
    // orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelect = {
        id: null, //订单id
        code: '', //订单code
        price: '', //订单金额
    }
    currentPage = 1
    pagesize = 20
    customerName = ''
    sourceName = ''
    orderDialogSelectTable = [] //选中数据
    tableDataOrder = [] //明细列表
    value = ''
    // 新
    financeRepeatOrderId = ''
    orderDialog = false
    orderSelected = {}
    previewPath =  ''
    previewName =  ''
    previewVisible =  false
    repeatUserName = '' //撞单同事
    loading = false

    get userName() {
        return UserModule.userName
    }


    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableDataOrder.forEach(item => num += Number(item.price))
        return num
    }



    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    menuBtn = menuBtn
    formatDate = formatDate



    clickAddOrder() {
        this.orderDialog = true
        this.getFinanceOrderListByFinanceRepeatOrder()
        this.defaultChecked()
    }

    defaultChecked() {
        this.$nextTick(() => {
            const order = (this.$refs.orderDialogTable as HTMLFormElement)
            order.clearSelection();
            this.tableDataOrder.forEach(row => {
                order.toggleRowSelection(row, true)
            })
        })
    }

    // 订单列表确认
    orderDialogConfirm() {
        this.formData.financeOrderId = (this.orderSelected as any).id
        this.tableDataOrder = []
        this.orderDialogSelectTable.map(item => {
            const Index = this.tableDataOrder.findIndex((items) => {
                return items.id === item.id
            })
            if (Index == -1) {
                this.tableDataOrder.push({
                    ...item,
                    priceOrScore: item.priceOrScore ? item.priceOrScore : 0,
                })
            }

        })
        this.orderDialog = false
        this.orderDialogInputValue = ''
    }

    // 订单列表取消
    handleOrderDialog() {
        this.orderDialogSelectTable.map(item => {
            this.tableDataOrder.map(items => {
                if (item.id !== items.id) {
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if (this.tableData.length > 0) {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row, true)
            });
        } else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }

    clickOrderDialogTableRow(row) {
        if (row.isSelect == '1') {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
        // if(!(row.isSelect == '1')) return
        // (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
    }

    thisBackMoneyChange(row, val) {
        // val = this.handleOninput(val,'2')
        this.tableDataOrder.forEach((item, index) => {
            if (item.id === row.id) {
                item.priceOrScore = val
            }
        })
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    getRowKeys(row) {
        return `${row.id}`
    }

    // 明细删除
    clickDelOrder(row) {
        this.tableDataOrder = this.tableDataOrder.filter(item => item.id !== row.id)
        this.orderDialogSelectTable = this.orderDialogSelectTable.filter(item => item.id !== row.id)
        this.tableDataOrder.forEach(row => {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row, true)
        })
    }

    changeCustomerEduCode(val) {
        if (val) {
            getCustomerListByEduCode({
                customerEduCode: val
            }).then((res: any) => {
                this.formData.repeatUserId = res.customerDirectorUserId
                this.repeatUserName = res.customerDirectorUserRealName
            })
        } else {
            this.repeatUserName = ''
            this.formData.repeatUserId = ''
        }
    }
    // 新建保存并提交
    clickSubmintButton() {
        const financeMarketCostDetailList = []

        if (this.tableDataOrder.length == 0) {
            this.$message.error('撞单明细必填，请添加订单！')
            return;
        }

        if(!this.formData.directorUserId){
            this.$message.error('负责人必填！')
            return;
        }

        const obj = {
            repeatUserId: this.formData.repeatUserId,
            financeOrderId: this.formData.financeOrderId,
            explain: this.formData.explain,
            financeRepeatOrderExplainList: this.fileList,
            url: this.formData.url,
            name: this.formData.name,
            directorUserId: this.formData.directorUserId,
            customerEduCode:this.formData.customerEduCode,
        };

        (this.$refs['formRef'] as HTMLFormElement).validate((valid1: boolean) => {
            if (valid1) {

                this.disabledButton = true
                this.loading = true
                setFinanceRepeatOrder(delNullProperty(obj)).then(() => {
                    this.$message.success('新建成功')
                    this.loading = false
                    setTimeout(() => {
                        this.closePage()
                        this.$router.go(-1)
                    }, 1500)
                    this.saveDraftDialogShow = false

                }).catch((err: Error) => {
                    if (err) {
                        this.disabledButton = false
                        this.loading=  false
                    }
                    if (err.message === '审批流报错') {
                        this.errorDialogShow = true
                    }
                })
            }
        })

    }

    closePage() {
        window.close()
    }



    // 订单列表搜索
    async clickorderDialogFilter() {
        if (this.select == '1') { //具体来源
            this.sourceName = this.orderDialogInputValue
            this.customerName = ''
        } else if (this.select == '0') { //客户名称
            this.customerName = this.orderDialogInputValue
            this.sourceName = ''
        }
        this.currentPage = 1
        this.getFinanceOrderListByFinanceRepeatOrder()
    }

    handleOrderFilter(val) {
        this.select = val
        this.orderDialogInputValue = ''
    }



    handleorderRowClick(row) {
        if (row.isSelect == '1') {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }

    orderDialogSelectionChange(selectionArr: any[]) {
        this.orderDialogSelectTable = selectionArr
        if(selectionArr.length > 0) {
            this.orderSelected = JSON.parse(JSON.stringify(selectionArr[0]))
            if(selectionArr.length > 1) {
                const orderTable = this.$refs.orderDialogTable as HTMLFormElement
                orderTable.clearSelection()
                orderTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for(const key in this.orderSelected) {
                this.orderSelected[key] = null
            }
        }
    }

    // 订单列表change
    // orderDialogSelectionChange(selectionArr: any[]) {
    //     if (selectionArr.length > 0) {
    //         this.orderDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
    //         if (selectionArr.length > 1) {
    //             const orderTableToggle = this.$refs.orderDialogTable as HTMLFormElement
    //             orderTableToggle.clearSelection()
    //             orderTableToggle.toggleRowSelection(selectionArr.pop())
    //         }

    //     } else {
    //         for (const key in this.orderDialogSelect) {
    //             this.orderDialogSelect[key] = null
    //         }
    //     }
    // }

    // 选过的订单不可选
    orderTableSelect(row) {
        return row.isSelect == '1'
    }

    // 订单列表
    async getFinanceOrderListByFinanceRepeatOrder() {
        const obj = {
            source: this.sourceName,
            financeRepeatOrderId: this.financeRepeatOrderId,
            customerName: this.customerName,
            page: this.currentPage,
            limit: this.pagesize,
        }
        const data: any = await getFinanceOrderListByFinanceRepeatOrder(delNullProperty(obj))
        this.orderDialogTaleData = data.financeOrderList
        this.orderDialogTotal = data.allNum
        this.orderDialogTableLoading = false

    }

    handleSizeChange(val) {
        this.pagesize = val
        this.getFinanceOrderListByFinanceRepeatOrder();
    }

    handleCurrentChange(val) {
        this.currentPage = val
        this.getFinanceOrderListByFinanceRepeatOrder();
    }


    /*
  * 关于上传相关资料的函数
  */
    handleUploadError() {
        this.$message.error('上传失败')
    }

    handleUploadSuccess(res: any, file: File, fileList: File[]) {
        if (res.error.returnCode === 0) {
            this.fileList.push({name: res.data.name, url: res.data.ossUrl})
            this.$message.success('上传成功')
        } else {
            this.$message.error(res.error.returnUserMessage)
        }
    }

    handleRemoveFile(file: File, fileList: File[]) {
        this.$message.success('删除文件')
        this.fileList = fileList.map((item: File) => ({name: item.name, url: item.url}))
    }

    beforeUpload(file, fileList) {
        if (file.size / (1024 * 1024) > 50) {  // 限制文件大小
            this.$message.warning(`当前限制文件大小不能大于50M`)
            return false
        }
    }

    changeDirectorUserId(e) {
        this.formData.directorUserId = e.id
    }


    @Watch("directorUserId", { deep: true })
    handle(userId: string) {
        if(!this.formData.directorUserId){
            this.formData.directorUserId = userId
        }
    }
    @Watch("userName", { deep: true })
    handleUserName(userName: string) {
        if(!this.formData.directorUserName){
            this.formData.directorUserName = userName
        }
    }

}
